import {AuthOptions, WebAuth} from 'auth0-js';
import {Inject, Injectable} from '@angular/core';
import {AUTH_OPTIONS} from '../providers/auth0';

@Injectable({providedIn: 'root'})
export class WebAuthService extends WebAuth {

	constructor(@Inject(AUTH_OPTIONS) config:AuthOptions) {
		super(config);
	}
}
